import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import CustomCursor from "@/components/site/CustomCursor";

import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminQuotes from "@/pages/AdminQuotes";
import AdminSimulators from "@/pages/AdminSimulators";
import AdminTestimonials from "@/pages/AdminTestimonials";
import AdminGallery from "@/pages/AdminGallery";
import AdminClients from "@/pages/AdminClients";
import AdminSettings from "@/pages/AdminSettings";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <div className="min-h-screen bg-black flex items-center justify-center text-neutral-500">Carregando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CustomCursor />
        <Toaster theme="dark" richColors position="top-right" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <Protected>
                <AdminLayout />
              </Protected>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="simulators" element={<AdminSimulators />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
